import React from 'react';

import { boatAPI } from 'api/requests';

import Button, { buttonColor } from 'Components/Button';
import { STEP_ID } from 'constants/boatApplication';
import FilePicker from 'Components/FilePicker';

export default ({ additionalFiles, applicationId, isFinalReview, goToStep, boatDetailsRequestInProcess }) => {
  if (boatDetailsRequestInProcess) return null;
  if (!additionalFiles.length) return null;

  return (
    <section className='scene_section'>
      <FilePicker
        isEditable={false}
        files={additionalFiles}
        notEditableStateSectionHeader='Additional Documents'
        httpParams={{ currentMethod: boatAPI.downloadFile, currentId: applicationId }}
      />

      {isFinalReview && (
        <Button
          color={buttonColor.planeOrange}
          label='Edit'
          buttonClassName='_height_20 _width_60 _position_absolute _right_130 _font_size_14'
          fontSize={14}
          onClick={() => goToStep(STEP_ID.LOAD_DOCUMENTS, true)}
        />
      )}
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/app/Scenes/BoatManufacturer/Application/Details/AdditionalFiles.jsx